
import React, { useRef, useState } from 'react'
import t from "../../../../service/translate.service";
import { Modal } from "antd";
import { CustomSelect } from '../../../../components/formComponents'
import { topics } from "../const/topics";

const TopicModal = (props) => {
  const inputRefs = useRef({})
  const [submitted, setSubmitted] = useState(false)
  const [errorsList, setErrorsList] = useState([])
  const [errorListVoice, setErrorListVoice] = useState(false)
  
  const generateErrorList = () => {
    const errors = []
    for (let key in inputRefs?.current) {
      const item = inputRefs?.current[key]
      if (key === 'topic') {
        const val = item?.props?.value
        const error = !val && t.CONSULTATIONS_SELECT_TOPIC
        if (error) {
          errors.push(
            <button
              key={1}
              type='button'
              onClick={() => {
                item.focus()
              }}
            >
              {error}
            </button>
          )
        }
      }
    }
    return errors
  }

  return (
    <Modal
      open={true}
      onCancel={() => {
        props.closeAppointment('topic');
      }}
      footer={[
        <button
          style={{
            marginRight: '10px'
          }}
          className="button secondary small"
          key="cancel"
          onClick={() => {
            props.closeAppointment('topic');
          }}
          aria-label={t.CLOSE_TOPIC}
        >
          {t.CONSULTATIONS_CANCEL}
        </button>,
        <button
          className="button primary small"
          key="ok"
          onClick={() => {
            props.setShowDescriptionModal(true);
            setSubmitted(false)
            setTimeout(() => {
              setErrorListVoice(true)
              setErrorsList(generateErrorList())
              setSubmitted(true)
            }, 100)

            if (props.selectedTopic) {
              props.setShowTopicModal(false);
            }
          }}
          aria-label={t.CONFIRM_TOPIC}
        >
          {t.CONSULTATIONS_OK}
        </button>
      ]}
      aria-labelledby="topicSelectionModalTitle"
      role="dialog"
      aria-live="assertive"
    >
      <div className="modal-body-wrapper">
        <p className={`${props.count === 0 ? 'error-message' : ''}`} id="topicSelectionMessage">
          {props.bookingTimeLeftMessage}
        </p>
        {submitted && (
          <div
            style={{
              backgroundColor: '#fff2f0',
              border: '1px solid #ffccc7',
              padding: '8px 12px',
              borderRadius: '8px'
              }}
            >
            <div
              className='error-list'
              role={errorListVoice ? "alert" : "none"}
              aria-live={errorListVoice ? "assertive" : "off"}
            >
              {t.REQUIRED_FIELD_MISSING}
              {errorsList?.map((err) => {
                return err
              })}
            </div>
          </div>
        )}
        <CustomSelect
          ref={(el) => (inputRefs.current['topic'] = el)}
          required={true}
          value={props.selectedTopic || null}
          options={topics}
          label={t.CONSULTATIONS_SELECT_TOPIC}
          placeholder={t.CONSULTATIONS_SELECT_TOPIC_PLACEHOLDER}
          defaultValue={topics[0]}
          onChange={selectedTopic => {
            setErrorListVoice(false)
            props.setSelectedTopic(selectedTopic)
          }}
          aria-labelledby="topicSelectLabel"
        />
        {!props.selectedTopic && props.showDescriptionModal && (
          <div className="error-message" role="alert" aria-live="assertive">
            {t.CONSULTATIONS_SELECT_TOPIC}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default TopicModal;
